import { doc, DocumentReference, getFirestore } from "firebase/firestore";
import React from "react";
import { useDocument, useDocumentData } from "react-firebase-hooks/firestore";
import { HelmetProvider } from "react-helmet-async";
import { useEventConfig } from "./EventConfig";
import escapeHtml from "escape-html";
import { Helmet } from "react-helmet";
import { EventConfigRoot } from "@max/common/event";

export const Tracking: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { eventId } = useEventConfig();
  const [event] = useDocumentData(
    doc(
      getFirestore(),
      `set_fresh_events/${eventId}`,
    ) as DocumentReference<EventConfigRoot>,
  );
  const { googleTagId, metaPixelId, tiktokPixelId } = event?.tracking || {};
  const isGoogleTagAdded =
    googleTagId && document.head.innerHTML.includes(escapeHtml(googleTagId));
  const isMetaPixelAdded =
    metaPixelId && document.head.innerHTML.includes(escapeHtml(metaPixelId));
  const isTiktokPixelAdded =
    tiktokPixelId &&
    document.head.innerHTML.includes(escapeHtml(tiktokPixelId));

  return (
    <HelmetProvider>
      <Helmet>
        {googleTagId &&
          !isGoogleTagAdded && [
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${escapeHtml(
                googleTagId,
              )}`}
            ></script>,
            <script>
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${escapeHtml(googleTagId)}');
            `}
            </script>,
          ]}
        {metaPixelId && !isMetaPixelAdded && (
          <script>
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${escapeHtml(metaPixelId)}');
              fbq('track', 'PageView');
            `}
          </script>
        )}
        {tiktokPixelId && !isTiktokPixelAdded && (
          <script>
            {`    
              !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
              }(window, document, 'ttq');
              ttq.load('${escapeHtml(tiktokPixelId)}');
              ttq.page();
            `}
          </script>
        )}
      </Helmet>
      {children}
    </HelmetProvider>
  );
};
